import { Container, makeStyles, Paper, Typography } from '@material-ui/core'
import { FC, useEffect, useRef, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import Form from '../component/um/settingDocument/Form'
import Dialog, { DialogType } from '../control/dialog/dialog'
import useTranslate from '../i18n/useTranslate'
import {
    useSettingDocument,
    GetDocumentResponse,
    UpdateDocumentRequest,
    GetDocumentRequest,
} from '../services/um/useSettingDocument'
import useAuthenStore from '../stores/authen/authenStore'

interface SettingDocumentEditProps {}
const SettingDocumentEdit: FC<SettingDocumentEditProps> = ({}) => {
    const classes = useStyle()
    const translate = useTranslate()
    const history = useHistory()
    const { putEditSettingDocument, getSettingDocument } = useSettingDocument()
    const [configDialog, setConfigDialog] =
        useState<Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>>()
    const dialogTwoRef = useRef<Record<string, Function>>()
    const [dataList, setDataList] = useState<GetDocumentResponse>()
    const authenStore = useAuthenStore()
    const params = useParams<{ id: string }>()
    const [initialUploadFile, setInitialUploadFile] = useState<any>()

    const onBack = () => {
        history.goBack()
    }

    const topicInitial = [
        {
            id: dataList?.documentID || 0,
            name_th: 'ภาษาไทย',
            name_en: 'Thai',
        },
        {
            id: dataList?.documentID || 0,
            name_th: 'ภาษาอังกฤษ',
            name_en: 'English',
        },
    ]

    const initialUpload = async (initDocumentInfo?: GetDocumentResponse['documentInfo']) => {
        setInitialUploadFile(initDocumentInfo)
    }

    const initialValue = {
        nameTH: dataList?.nameTH ?? null,
        nameEN: dataList?.nameEN ?? null,
        shortNameTH: dataList?.shortNameTH ?? null,
        shortNameEN: dataList?.shortNameEN ?? null,
        submittedTypeID: dataList?.submittedTypeID ?? null,
        code: dataList?.code ?? null,
        isDisplayDocument: dataList?.isDisplayDocument ?? null,
        documentInfo: initialUploadFile,
    }

    const onRefDialogTwo = (func: Record<string, Function>) => {
        dialogTwoRef.current = func
    }

    const onSave = async (values: GetDocumentResponse) => {
        const param: UpdateDocumentRequest = {
            nameTH: values.nameTH ?? null,
            nameEN: values.nameEN ?? null,
            shortNameTH: values.shortNameTH ?? null,
            shortNameEN: values.shortNameEN ?? null,
            submittedTypeID: values.submittedTypeID ?? null,
            recID: authenStore.profile.irb,
            userID: authenStore.profile.userId ?? 0,
            code: values.code,
            isDisplayDocument: values.isDisplayDocument ?? null,
            documentInfo: values.documentInfo,
        }
        const result = await putEditSettingDocument(param, parseInt(params.id))
        let optionDialog: any = {
            title: translate.get('ALERT.TITLE.NOTIFICATION'),
            content: translate.get('ALERT.CONTENT.SAVE_SUCCESS'),
            type: 'alert-message',
            onAfterClose: onBack,
        }
        if (result.status !== 1) {
            optionDialog = {
                title: translate.get('ALERT.TITLE.NOTIFICATION'),
                content: translate.get('MESSAGE.M022'),
                type: 'alert-message',
            }
        }
        setConfigDialog(optionDialog)
    }

    const handleClickSubmit = async (values: GetDocumentResponse) => {
        setConfigDialog({
            title: translate.get('ALERT.TITLE.NOTIFICATION'),
            content: translate.get('ALERT.CONTENT.NEED_TO_SAVE'),
            type: 'alert-confirm',
            onClickConfirm: () => onSave(values),
        })

        dialogTwoRef.current?.openDialog()
    }

    const loadData = async () => {
        let param: GetDocumentRequest = {
            documentID: parseInt(params.id),
        }
        const result = await getSettingDocument(param)
        setDataList(result)
        initialUpload(result.documentInfo)
    }

    useEffect(() => {
        if (authenStore.profile.userId) {
            loadData()
        }
    }, [])

    return (
        <Container maxWidth="lg">
            <Typography variant="h5" style={{ fontWeight: 'bold', marginBottom: '20px' }}>
                {translate.get('UM.SETTINGDOCUMENT.EDIT.HEADER')}
            </Typography>
            <Paper className={classes.paper}>
                <Form
                    onClickBack={onBack}
                    initialValues={initialValue}
                    onSubmit={handleClickSubmit}
                    topicInitial={topicInitial}
                    initialUploadFile={initialUploadFile}
                />
                <Dialog onRef={onRefDialogTwo} {...configDialog} />
            </Paper>
        </Container>
    )
}
export default SettingDocumentEdit
const useStyle = makeStyles((theme) => ({
    paper: {
        width: '100%',

        marginBottom: '10px',
        padding: '20px',
        [theme.breakpoints.down('sm')]: {
            backgroundColor: 'unset',
            boxShadow: 'unset',
            margin: '0px',
        },
    },
}))
